// extracted by mini-css-extract-plugin
export default {"overridesLogInNavigationMobile":"LogInNavigationMobile-module--overrides--LogInNavigationMobile--S3+OB"};